import React, { useEffect, useState } from 'react';

export default function TextAreaControl({ value, required = false, change, label = '', help = '', placeholder = '', valid = true, type = 'text', classlist = '', disabled = false, rows = 3, description = null }) {
  return (
    <div className='text-control'>
      {label && <label className='form-label'>{label} {required && <span className='required'>*</span>}</label>}
      {description && <p>{description}</p>}
      <textarea disabled={disabled ? 'disabled' : ''} rows={rows} type={type} className={`${valid && 'valid'} ${classlist}`} placeholder={placeholder} value={value} onChange={(e) => { change(e.target.value) }} />
      {help && <div className='form-help'>{help}</div>}
    </div>
  )
}
